import z from "zod";
import { DATE_REGEX } from "../constants";
import { isValidCnh, isValidDate } from "../validations";

export const editDriverSchema = z
	.object({
		name: z.string().min(1, "Nome é obrigatório"),
		cpf: z.string().regex(/^\d+$/, "CPF deve conter apenas números"),
		email: z.string().email("E-mail inválido"),

		vehicleId: z.string().nullable().optional(),
		function: z.string().optional(),

		cnh: z.string().optional().refine(isValidCnh, "Número da CNH inválido"),

		cnhExpiration: z
			.string()
			.optional()
			.refine((val) => !val || DATE_REGEX.test(val), "Formato de data inválido")
			.refine(isValidDate, "Data inválida"),

		categoryCnh: z.array(z.string()).optional(),

		photoCnh: z
			.instanceof(File)
			.optional()
			.refine(
				(file) => !file || file.size <= 2 * 1024 * 1024,
				"A foto está grande demais. Diminua para caber em até 2MB."
			),
	})
	.superRefine((data, ctx) => {
		const hasCnh = !!data.cnh && data.cnh.trim() !== "";

		const hasAnyCnhFieldFilled =
			!!data.cnhExpiration?.trim() ||
			(data.categoryCnh?.length ?? 0) > 0 ||
			!!data.photoCnh;

		if (hasCnh) {
			if (!data.cnhExpiration?.trim()) {
				ctx.addIssue({
					path: ["cnhExpiration"],
					code: "custom",
					message: "Data de vencimento da CNH é obrigatória",
				});
			}

			if (!data.categoryCnh || data.categoryCnh.length === 0) {
				ctx.addIssue({
					path: ["categoryCnh"],
					code: "custom",
					message: "Categoria da CNH é obrigatória",
				});
			}
		}

		if (!hasCnh && hasAnyCnhFieldFilled) {
			ctx.addIssue({
				path: ["cnh"],
				code: "custom",
				message: "Informe o número da CNH.",
			});
		}
	});

export type EditDriverFormValues = z.infer<typeof editDriverSchema>;
